function updateProgress() {
  const block = document.querySelector('.why__astons__block');
  const items = document.querySelectorAll('.why__astons__item');
  const circles = document.querySelectorAll('.item__circle');

  if (!block) return;

  const isMobile = window.innerWidth <= 991;
  let activeIndex = -1;

  if (isMobile) {
    const blockRect = block.getBoundingClientRect();
    const scrollLeft = block.scrollLeft;
    const maxScroll = block.scrollWidth - block.clientWidth;
    const progress = scrollLeft / maxScroll;

    items.forEach((item, i) => {
      const itemLeft = item.getBoundingClientRect().left - blockRect.left;
      if (itemLeft < block.clientWidth * progress + 50) {
        item.classList.add('active');
        activeIndex = i;
      } else {
        item.classList.remove('active');
      }
    });
  } else {
    const rect = block.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const blockHeight = block.offsetHeight;
    const screenMiddle = windowHeight / 2;

    const scrolled = Math.min(Math.max(screenMiddle - rect.top, 0), blockHeight);
    const progress = scrolled / blockHeight;
    const lineBottomY = rect.top + progress * blockHeight;

    items.forEach((item, i) => {
      const itemTop = item.getBoundingClientRect().top;
      if (itemTop < lineBottomY) {
        item.classList.add('active');
        activeIndex = i;
      } else {
        item.classList.remove('active');
      }
    });
  }

  circles.forEach((circle, i) => {
    if (i === activeIndex) {
      circle.classList.add('active');
    } else {
      circle.classList.remove('active');
    }
  });
}

window.addEventListener('scroll', updateProgress);
window.addEventListener('resize', updateProgress);
document.querySelector('.why__astons__block')?.addEventListener('scroll', updateProgress);
document.addEventListener('DOMContentLoaded', updateProgress);
